import React, { useState } from 'react';
import { LostLeadsDonut } from '../features/perdidos/LostLeadsDonut';
import { fmt, fmtDateOnly } from '../lib/formato';

function LostLeadsView({ leads }) {
  // Repescagem continua contando como perda: sem isso a tela esvazia e o mês já fechado
  // passa a ter uma perda a menos, mudando o passado retroativamente.
  const lostLeads = leads.filter(l => ['perdido','repescagem'].includes(l.stage));
  const [sortBy, setSortBy] = useState('date');

  const REASONS = [
    { key:'sem_resposta', label:'Sem resposta',      color:'#FF9500', short:'Sem resposta' },
    { key:'preco',        label:'Preço',             color:'#FF3B30', short:'Preço' },
    { key:'concorrente',  label:'Concorrente',       color:'#BF5AF2', short:'Concorrente' },
    { key:'atendimento_ineficiente', label:'Atendimento ineficiente', color:'#007AFF', short:'Atendimento ineficiente' },
    { key:'outros',       label:'Outros / Não informado', color:'#8E8E93', short:'Outros' },
  ];

  const donutData = REASONS.map(r => ({
    ...r,
    count: r.key==='outros'
      ? lostLeads.filter(l=>!l.loss_reason||l.loss_reason==='outros').length
      : lostLeads.filter(l=>l.loss_reason===r.key).length
  }));

  const totalValue = lostLeads.reduce((s,l)=>s+(Number(l.value)||0),0);

  const sorted = [...lostLeads].sort((a,b)=>{
    if (sortBy==='value') return (Number(b.value)||0)-(Number(a.value)||0);
    return (b.updated_at||b.created_at||'')>(a.updated_at||a.created_at||'')?1:-1;
  });

  if (lostLeads.length===0) return <div className="flex flex-col items-center justify-center py-24 text-gray-400">
    <span className="text-5xl mb-4">🎉</span>
    <p className="text-lg font-semibold">Nenhum lead perdido</p>
    <p className="text-sm mt-1">Continue assim!</p>
  </div>;

  return <div className="space-y-6">
    {/* Header */}
    <div>
      <h2 className="text-xl font-bold text-gray-900">📉 Leads Perdidos</h2>
      <p className="text-sm text-gray-500 mt-0.5">{lostLeads.length} lead{lostLeads.length!==1?'s':''} perdido{lostLeads.length!==1?'s':''} — {fmt(totalValue)} em valor potencial</p>
    </div>

    {/* Cards de razão + Donut */}
    <div className="flex gap-6 items-start flex-wrap">
      <LostLeadsDonut data={donutData} size={180} />
      <div className="flex flex-col gap-2 flex-1 min-w-[200px]">
        {donutData.map(r=><div key={r.key} className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full flex-shrink-0" style={{background:r.color}}></div>
          <span className="text-sm text-gray-700 flex-1">{r.label}</span>
          <span className="text-sm font-bold text-gray-900">{r.count}</span>
          <span className="text-xs text-gray-400 w-10 text-right">{lostLeads.length>0?Math.round(r.count/lostLeads.length*100):0}%</span>
        </div>)}
      </div>
    </div>

    {/* Lista */}
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-700">Lista de perdidos</h3>
        <select className="apple-input text-xs px-3 py-1.5" value={sortBy} onChange={e=>setSortBy(e.target.value)}>
          <option value="date">Mais recente</option>
          <option value="value">Maior valor</option>
        </select>
      </div>
      <div className="space-y-2">
        {sorted.map(l=>{
          // Motivo desconhecido cai em "outros" pela chave: o índice fixo apontaria para outra
          // categoria assim que o array ganhasse um item antes dele.
          const r=donutData.find(d=>d.key===(l.loss_reason||'outros'))||donutData.find(d=>d.key==='outros');
          return <div key={l.id} className="bg-white rounded-2xl p-3 shadow-sm border border-gray-100 flex items-center gap-3">
            <div className="w-2 h-10 rounded-full flex-shrink-0" style={{background:r.color}}></div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-gray-800 text-sm truncate">{l.company_name}</div>
              <div className="text-xs text-gray-400 mt-0.5 flex items-center gap-2">
                <span style={{color:r.color}}>{r.short}</span>
                {l.seller_name && <span>· 👤{l.seller_name}</span>}
                {l.updated_at && <span>· {fmtDateOnly(l.updated_at.slice(0,10))}</span>}
              </div>
            </div>
            {l.value>0 && <span className="text-sm font-bold text-gray-500 flex-shrink-0">{fmt(l.value)}</span>}
          </div>;
        })}
      </div>
    </div>
  </div>;
}

// ─── C-59: negociações concluídas ─────────────────────────

export { LostLeadsView };
